import React from 'react';
import { useDialog } from '../../components/dialog/use-dialog';
import ActionButton from '../../components/buttons/ActionButton';
import { useGetTaskListQuery } from '../api/api';
import { DataTypesMap } from '../api/types';
import { TaskActionButton } from './TaskActionButton';

interface TaskListPageProps {
	tenantId: number;
}

const TaskList: React.FC<TaskListPageProps> = ({ tenantId }) => {
	const { data, isFetching } = useGetTaskListQuery({ tenantId: tenantId });
	const { onOpen: openCreateTaskDialog } = useDialog('biHubTaskCreate');

	if (!data && isFetching) {
		return (
			<div className="d-flex justify-content-center align-items-center">
				<div className="spinner-border" role="status">
					<span className="visually-hidden">Loading...</span>
				</div>
			</div>
		)
	}

	return (
		<div>
			<div className="d-flex justify-content-end align-items-center">
				<ActionButton
					onClick={() => openCreateTaskDialog({ tenantId: tenantId, })}
					text='Add New Task'
					showPopConfirm={false}
					color='primary'
					fontIcon='fa fa-plus'
				/>
			</div>

			<div className="mt-4">
				<table className="table table-fixed align-middle gx-5 no-footer table-row-bordered striped border border-gray-200">
					<thead className='bg-gray-200'>
						<tr>
							<th scope="col">Name</th>
							<th scope="col">Description</th>
							<th scope="col">Type</th>
							<th scope="col">Action</th>
							<th scope="col"></th>

						</tr>
					</thead>
					<tbody>

						{data?.map((task, index) => (
							<tr key={task.id}>
								<td>{task.name}</td>
								<td>{task.description}</td>
								<td>{DataTypesMap.get(task.type)}</td>
								<td>{task.action}</td>

								<td className='d-flex justify-content-end' style={{ maxHeight: '60px' }}>
									<TaskActionButton id={task.id} tenantId={tenantId} />
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default TaskList;